/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_H1Inputs */

const en_to_typescript_h1 = /** @type {(inputs: To_Typescript_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON to TypeScript Interface Generator`)
};

const ko_to_typescript_h1 = /** @type {(inputs: To_Typescript_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScript 인터페이스 생성기`)
};

const ja_to_typescript_h1 = /** @type {(inputs: To_Typescript_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON → TypeScriptインターフェース生成ツール`)
};

/**
* | output |
* | --- |
* | "JSON to TypeScript Interface Generator" |
*
* @param {To_Typescript_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_h1 = /** @type {((inputs?: To_Typescript_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_h1(inputs)
	if (locale === "ko") return ko_to_typescript_h1(inputs)
	return ja_to_typescript_h1(inputs)
});